<template>
  <div>
    <div class="message_area">
      お申込みがキャンセルされました。<br />タブレットをお持ちの場合、タブレットを販売員にお渡しください。
    </div>

    <div class="next">
      <el-button type="primary" icon="el-icon-arrow-right" @click="backToTop">業務選択画面へ戻る</el-button>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$store.state.hasCancel = false
  },
  methods: {
    backToTop() {
      this.transitionClearCache('/')
      //this.transitionSame('top');
    }
  }
}
</script>

<style lang="scss" scoped>
.message_area {
  padding: 15px;
  border: 2px solid #eee;
  text-align: center;
}

.next {
  margin-top: 40px;
  text-align: center;
  .el-button {
    border-radius: 0;
    padding-left: 30px;
    padding-right: 30px;
  }
}
</style>
